import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import moment from 'moment-timezone';
import { isNil, isString } from 'lodash';

import EmptyPositionCard from './EmptyPositionCard';
import PositionCard from './PositionCard';

const StyledPositionsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-auto-rows: 1fr;
  grid-gap: ${props => props.theme.spacing[3]};

  // Grid for IE11
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    display: flex;
    flex-wrap: wrap;

    & > * {
      width: 30%;
      box-sizing: border-box;
    }
  }
`;

const Positions = (props) => {
  const renderPositions = ({
    belongsToCurrentUser,
    onCancelClick,
    onExtendClick,
    onViewProfileClick,
    onTimesheetClick,
    onViewPastTimesheets,
    positions,
    showCancelMenuItem,
    showPastTimesheetMenuItem,
    weployees,
  }) => {
    const filledPositions = positions
      .filter(position => isString(position.weployee))
      .sort((positionA, positionB) => moment(positionA.finishTime) - moment(positionB.finishTime));
    const emptyPositions = positions.filter(position => isNil(position.weployee));
    const combinedPositions = [...filledPositions, ...emptyPositions];

    return (combinedPositions
      .map((position) => {
        const positionCardCommonProps = {
          onCancelClick,
          position,
          key: position.id,
        };
        return (
          position.weployee
            ? <PositionCard
              onViewProfileClick={onViewProfileClick}
              onExtendClick={onExtendClick}
              onTimesheetClick={onTimesheetClick}
              onViewPastTimesheets={onViewPastTimesheets}
              showApproveCallToAction={position.isApprovable}
              showCancelMenuItem={showCancelMenuItem}
              showExtendCallToAction={position.extendable}
              showPastTimesheetMenuItem={showPastTimesheetMenuItem}
              weployee={weployees[position.weployee]}
              {...positionCardCommonProps}
            />
            : <EmptyPositionCard
              showCancelMenuItem={showCancelMenuItem && belongsToCurrentUser}
              {...positionCardCommonProps}
            />
        );
      })
    );
  };

  return (
    props.positions.length
      ? <StyledPositionsContainer>{ renderPositions(props) }</StyledPositionsContainer> : 'You do not have any positions for this job.'
  );
};

Positions.propTypes = {
  positions: PropTypes.arrayOf(PropTypes.object),
};

Positions.defaultProps = {
  positions: [],
};

export default Positions;
